<template>
  <div class="target-platforms">
    <div class="vx-row mb-10">
      <div class="vx-col w-full">
        <h5>
          {{ $t('Target Platforms') }}
        </h5>
      </div>
    </div>

    <div class="vx-row mt-6 mb-10">
      <div class="vx-col w-full">
        <span v-on:click="$gtag.event('Step3_PublishersTab_Websites')" id="create-campaign-s3-platform-websites-button" class="mr-3 span-tag" :class="{'span-tag-active' : looking_for == 'websites'}" @click="changeLookingFor('websites')">
          {{ $t('Websites') }} ({{ value.websites.length }} {{ $t('Selected') }})
        </span>

        <span v-on:click="$gtag.event('Step3_PublishersTab_Apps')" id="create-campaign-s3-platform-apps-button" class="mt-4 mr-3 span-tag" :class="{'span-tag-active' : looking_for == 'apps'}" @click="changeLookingFor('apps')">
          {{ $t('Mobile Applications') }} ({{ value.apps.length }} {{ $t('Selected') }})
        </span>
      </div>
    </div>

    <div class="vx-row mt-6 mb-10">
      <div class="vx-col w-full">
        <div class="autocomplete">
          <input id="create-campaign-s3-platform-search-input" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" v-model="filterText" :placeholder="search_placeholder" class="autocomplete-input">
        </div>
      </div>
    </div>

    <div class="vx-row mt-6 mb-5">
      <div class="vx-col w-full">
        <vs-checkbox id="create-campaign-s3-platform-select-all-checkbox" class="ml-0" color="#6DC5D0" v-model="select_all" @change="selectAll">{{ $t('Select All') }}</vs-checkbox>
      </div>
    </div>

    <div class="vx-row pt-3 h-64 overflow-y-scroll treeContainer mx-0">
      <div class="vx-col w-full">
        <tree :data="tree" :filter="filterText" :options="treeOptions" ref="tree" @node:unchecked="removeTargetFromTree" @node:checked="addTargetFromTree">
          <span class="tree-text" slot-scope="{ node }">
            <template>
              <span v-if="node.data.hasOwnProperty('websites_count') || node.data.hasOwnProperty('apps_count')" class="inline-block align-middle mr-3">
                {{ node.text }}
                (
                  {{
                    itemsCountPerCategory[node.data.id]
                      ? (itemsCountPerCategory[node.data.id][looking_for] ? itemsCountPerCategory[node.data.id][looking_for] : 0)
                      : 0
                  }}
                  /
                  {{ looking_for == 'websites' ? node.data.websites_count : node.data.apps_count }}
                )
              </span>
              <span v-else class="inline-block align-middle mr-3">
                {{ node.text }}
              </span>
            </template>
          </span>
        </tree>
      </div>
    </div>

    <div class="vx-row mt-8">
      <div class="vx-col w-full">
        <vs-checkbox @input="$gtag.event('Step3_PublishersTab_IncludeNew')" id="create-campaign-s3-platform-include-new-button" class="ml-0" color="#6DC5D0" v-model="value.include_new_platforms">{{ $t('Include all new websites.') }}</vs-checkbox>
      </div>
    </div>
  </div>
</template>


<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import {cloneDeep} from 'lodash'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    industry_id: {
      type: Number,
      required: true
    },
    editing: {
      type: Boolean,
      default: false,
      required: false
    },
    account_id: {
      type: Number,
      required: true
    },
    adsetIndex: {
      type: Number,
      required: true
    },
    isRefillingFromAnAudience: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)

        this.isSelectAllChecked(newVal)
      },
      deep: true
    }
  },
  components: {
    Autocomplete
  },
  data () {
    return {
      looking_for: 'websites', // only in [websites, apps]
      target: {
        websites: [],
        apps: []
      },
      categories: [],
      counts: {
        websites: [],
        apps: []
      },
      filterText: '',
      tree: this.getTreeData(),
      select_all: true,
      fire_platforms_events: true,
      treeOptions: {
        checkbox: true
      },
      isDataFilled: false
    }
  },
  mounted () {
    // after component is ready i need to check if there is isps in the "main state" if there any will trigger a request and select it
    // and if not i need to fetch all platforms
    // setTimeout(async () => {
    //   const response = await this.initRequest()
    //   response.data.payload.forEach(item => {
    //     this.addTarget(
    //       item,
    //       this.value.websites.length && this.value.apps.length ? this.value[item.type].includes(item.id) : true,
    //       item.type !== this.looking_for
    //     )
    //   })
    // }, 0)

    // when a user removes a websites from price flooring table it must be removed from here
    this.$root.$on(`price-flooring:${this.adsetIndex}:platform-deleted`, (domain) => {
      if (!domain) {
        return
      }

      const item = this.target[domain.type].find((i) => i.id === domain.id)

      if (item) {
        // Fire event "platforms:changed"
        this.removeTarget(item)

        if (this.$refs.tree) {
          const treeItem = this.$refs.tree.find(item.name)
          if (treeItem) {
            treeItem.uncheck()
          }
        }
      }
    })

    // when a user removes a websites from price flooring table it must be added from here
    this.$root.$on(`price-flooring:${this.adsetIndex}:platform-added`, (domain) => {
      if (!domain) {
        return
      }

      const item = this.target[domain.type].find((i) => i.id === domain.id)

      if (item) {
        // Fire event "platforms:changed"
        this.addTarget(item)

        if (this.$refs.tree) {
          const treeItem = this.$refs.tree.find(item.name)
          if (treeItem) {
            treeItem.check()
          }
        }
      }
    })
  },
  computed: {
    search_placeholder () {
      return this.looking_for === 'websites' ? this.$t('Search for website.') : this.$t('Search for mobile applications.')
    },
    categoriesHashMap () {
      if (this.categories.length) {
        return this.categories.map((category) => {
          const result = {}
          result[category.id] = true
        })
      }
      return {}
    },
    itemsCountPerCategory () {
      const $return = []

      if (this.categories.length) {
        this.categories.forEach(category => {
          let websites = this.counts['websites'].find(i => i.category_id === category.id)

          if (!websites) {
            websites = {count: 0}
          }

          let apps = this.counts['apps'].find(i => i.category_id === category.id)

          if (!apps) {
            apps = {count: 0}
          }

          $return[category.id] = {
            websites: websites.count,
            apps: apps.count
          }
        })
      }

      return $return
    }
  },
  methods: {
    async getTreeData (looking_for = 'websites', forceFill = false, skipRefillingFromAnAudience = false, hideLoader = true) {
      /**
       * hay maintainer here I'm explaining the states that are critical to fill
       * this.value.websites : the selected websites ids
       * this.value.apps : the selected apps ids
       *
       ** like a local data base of websites in the component level
       * this.target.websites : the selected websites object
       * this.target.apps : the selected apps object
       *
       ** a local data base  in component level
       * this.categories: the categories objects
       *
       ** a database for counts
       * this.counts.websites : the seleccted websites count per category
       * this.counts.apps : the seleccted apps count per category
       */

      if (!['websites', 'apps'].includes(looking_for)) {
        return
      }

      const response = await this.initRequest(null, true, hideLoader)

      const isRefillingFromAnAudience = skipRefillingFromAnAudience ? false : this.isRefillingFromAnAudience

      if (!this.isDataFilled || forceFill || isRefillingFromAnAudience) {
        const websites_data = response.data.payload.map(i => i.children.filter(v => v.state.checked).map(v => v.data).flat()).flat().filter(i => i.type === 'websites')
        const apps_data = response.data.payload.map(i => i.children.filter(v => v.state.checked).map(v => v.data).flat()).flat().filter(i => i.type === 'apps')

        const refillValues = (!this.editing || forceFill)
        const isWebsitesNotFilled = (looking_for === 'websites' || !this.isDataFilled)
        const isAppsNotFilled = (looking_for === 'apps' || !this.isDataFilled)

        const selectableWebsitesIds = websites_data.map(i => i.id)
        const selectableAppsIds = apps_data.map(i => i.id)

        if (isRefillingFromAnAudience) {
          this.value.websites = this.value.websites.filter(id => selectableWebsitesIds.includes(id))
          this.value.apps = this.value.apps.filter(id => selectableAppsIds.includes(id))
        } else {
          if (refillValues && isWebsitesNotFilled) {
            this.value.websites = selectableWebsitesIds
          }

          if (refillValues && isAppsNotFilled) {
            this.value.apps = selectableAppsIds
          }
        }

        this.target.websites = websites_data
        this.target.apps = apps_data

        this.isDataFilled = true
      }

      this.categories = response.data.payload.map(i => i.data)

      this.counts.websites = response.data.payload.map((i) => {
        return {
          category_id: i.data.id,
          count: this.target.websites.filter(v => this.value.websites.includes(v.id) && v.category_id === i.data.id).length
        }
      })

      this.counts.apps = response.data.payload.map((i) => {
        return {
          category_id: i.data.id,
          count: this.target.apps.filter(v => this.value.apps.includes(v.id) && v.category_id === i.data.id).length
        }
      })

      const treeData = response.data.payload

      treeData.forEach((categoryTree, index) => {
        const selectedCount = this.counts[looking_for].filter(i => i.category_id === categoryTree.data.id)[0].count

        treeData[index].state.checked = selectedCount > 0 ? categoryTree.data[`${looking_for}_count`] === selectedCount : false

        treeData[index].children.forEach(treeItem => {
          if (this.editing || this.value[looking_for].length) {
            treeItem.state.checked = treeItem.data.state.checked && this.value[looking_for].includes(treeItem.data.id)
          } else {
            treeItem.state.checked = false
          }
        })

        treeData[index].children = treeData[index].children.filter(i => i.data.type === looking_for)
      })


      this.isSelectAllChecked(this.value)

      return Promise.resolve(treeData.filter(i => i.data[`${looking_for}_count`] > 0))
    },
    initRequest (looking_for = null, forTree = false, hideLoader = false) {
      const params = {
        industry_id: this.industry_id,
        for_tree: forTree ? 1 : 0,
        account_id: this.account_id
      }

      if (looking_for !== null) {
        params.type = looking_for
      }

      return window.axios.get('/recommendations/get/platforms', {
        hideLoader,
        params
      })
    },
    async reInitSelections () {


      const response = await this.initRequest()

      response.data.payload.forEach(item => {
        this.addTarget(item)
      })


    },
    changeLookingFor (looking_for, oldLookingFor = 'websites', hideLoader = false) {
      this.resetValues('soft').then(async () => {


        this.filterText = ''

        // change looking for value
        if (looking_for === 'all') {
          this.looking_for = oldLookingFor
        } else {
          this.looking_for = looking_for
        }

        const data = await this.getTreeData(this.looking_for, false, false, hideLoader)
        this.$refs.tree.setModel(data)

        this.isSelectAllChecked(this.value)

      })
    },
    addCategory (item) {
      const categoryExist = this.categoriesHashMap[item.id]
      if (!categoryExist) {
        this.categories.push(item)
      }
      return true
    },
    addTarget (item, isSelected = true) {
      if (item.state.disabled) {
        return
      }

      const isCategoryAdded = this.addCategory(item.category)
      // check if item exists
      if (isCategoryAdded) {
        if (!this.target[item.type].find(i => item.id === i.id)) {
          this.target[item.type].push(item)
        }

        if (isSelected) {
        // push to value
          if (!this.value[item.type].find(i => item.id === i)) {
            this.value[item.type].push(item.id)

            // push to counts
            const countedByCategory = this.counts[item.type].find(i => i.category_id === item.category.id)
            if (!countedByCategory) {
              this.counts[item.type].push({
                category_id: item.category.id,
                count: 1
              })
            } else {
              countedByCategory.count++
            }
          }
        }
      }

    },
    removeTarget (item) {
      // remove from this.value
      const valueIndex = this.value[item.type].findIndex(i => i === item.id)
      if (valueIndex !== -1) {
        this.value[item.type].splice(valueIndex, 1)

        // remove from counts
        const countedByCategory = this.counts[item.type].find(i => i.category_id === item.category.id)
        if (countedByCategory && countedByCategory.count > 0) {
          countedByCategory.count--
        }
      }
    },
    removeTargetFromTree (node) {
      if (node.data.hasOwnProperty('category_id')) { // that means that the node is isp
        this.removeTarget(node.data)
      }
    },
    addTargetFromTree (node) {
      if (node.data.state && node.data.state.disabled) {
        node.states = {...node.states, ...node.data.state}
        node.uncheck()
        node.unselect()
      }

      if (node.data.hasOwnProperty('category_id')) { // that means that the node is isp
        this.addTarget(node.data)
      }
    },
    isSelectAllChecked (newValue) {
      const target = cloneDeep(this.target)

      const data = target.websites.concat(target.apps)

      const categories = data.map(i => i.category)

      const categoriesUnique = []

      categories.forEach(category => {
        if (!categoriesUnique.find(i => i.id === category.id)) {
          categoriesUnique.push(category)
        }
      })

      const total_websites = categoriesUnique.map(i => i.websites_count).reduce((a, b) => a + b, 0)
      const total_apps = categoriesUnique.map(i => i.apps_count).reduce((a, b) => a + b, 0)

      this.select_all = (this.looking_for === 'websites' ? total_websites : total_apps) === (this.looking_for === 'websites' ? newValue.websites.length : newValue.apps.length)
    },
    async selectAll () {
      if (this.looking_for === 'websites') {
        this.$gtag.event('Step3_PublishersTab_Websites_All')
      } else {
        this.$gtag.event('Step3_PublishersTab_Apps_All')
      }

      if (this.select_all) {
        // this.changeLookingFor('all', this.looking_for)
        const data = await this.getTreeData(this.looking_for, true, true, false)
        this.$refs.tree.setModel(data)
        return
      }

      // reset the selected value
      this.value[this.looking_for] = []

      // reset the counts
      this.counts[this.looking_for] = []

      const selection = this.$refs.tree.findAll({ state: { checked: true } })
      selection.unselect()
      selection.uncheck()

      // const target = window._.cloneDeep(this.target)

      // const data = this.looking_for === 'websites' ? target.websites : target.apps

      // data.forEach((item) => {
      //   // this.removeTarget(item)
      //   // to uncheck
      //   const node = this.$refs.tree.find(item.name)
      //   if (node.length) {
      //     node[0].uncheck()
      //   }
      // })
    },
    resetValues (resetType) {
      return new Promise(resolve => {
        // reset the counts
        this.counts = {
          websites: [],
          apps: []
        }

        // clean the tree
        this.categories.forEach(category => {
          if (this.$refs.tree.find(category.name).length > 0) {
            this.$refs.tree.remove(category.name)
          }
        })

        // reset type is created to handle switching between the looking for option
        if (resetType === 'soft') {
          resolve()
          return
        }

        // clean the selected items
        this.target = {
          websites: [],
          apps: []
        }

        // reset the selected value
        this.value.websites = []
        this.value.apps = []

        resolve()
      })
    }
  }
}
</script>

<style lang="scss">
.target-platforms {
  .tree-children {
    margin-left: 24px;
  }
}
</style>
